import { SetStateAction, useEffect, useState } from 'react';
import { Tabs } from '@pmi/dsm-react';
import styles from './tabsCard.module.scss';
import UsersTab from './UsersTab';
import AdminsTab from './AdminsTab';
import InternalAdminsTab from './InternalAdminsTab';
import useUser from '../../../shared/hooks/useUser';

interface TabCardProps {
  internalAdmin: boolean;
}

export default function TabsCard({ internalAdmin }: TabCardProps) {
  const [value, setValue] = useState(0);
  const user = useUser();
  const defaultTabs = [
    { label: 'Users', value: 0 },
    { label: 'Administrators', value: 1 },
  ];
  const [tabs, setTabs] = useState(defaultTabs);

  const handleChange = (event: any, newValue: SetStateAction<number>) => {
    setValue(newValue);
  };
  useEffect(() => {
    if (internalAdmin) {
      setTabs([
        ...defaultTabs,
        {
          label: 'PMI Internal',
          value: 2,
        },
      ]);
    } else {
      setTabs(defaultTabs);
    }
  }, []);
  return (
    <div className={`${styles.peopleTabsCard} people-page-tabs`}>
      <div className={`card ${styles.peopleTabsCardContainer} p-0`}>
        <div className="card-body p-3">
          <div className={styles.__tabsContainer}>
            <Tabs
              labels={tabs}
              onChange={handleChange}
              value={value}
              data-testid="tabs-card"
            />
          </div>
          <div className="d-block my-3">
            {value === 0 && <UsersTab />}
            {value === 1 && <AdminsTab currentUser={user} />}
            {value === 2 && internalAdmin && <InternalAdminsTab />}
          </div>
        </div>
      </div>
    </div>
  );
}
